import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CHANGE_DISHES: "Velg retter selv",
      DISCARD_CHANGES: "Angre endringer",
    },
    se: {
      CHANGE_DISHES: "Välj rätter själv",
      DISCARD_CHANGES: "Ångra ändringar",
    },
    dk: {
      CHANGE_DISHES: "Ændr retter",
      DISCARD_CHANGES: "Fortryd ændringer",
    },
  } as const
)[language];
